import { useEffect } from "react";

export function useMenuDynamicStyles(
  bannerBgColor,
  tabMenuColor,
  sidebarColor,
  tabMenuActionColor,
  textColor,
  textColorActive
) {
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--bannerBgColor",
      bannerBgColor
    );
    document.documentElement.style.setProperty("--tabMenuColor", tabMenuColor);
    document.documentElement.style.setProperty("--sidebarColor", sidebarColor);
    document.documentElement.style.setProperty(
      "--tabMenuActionColor",
      tabMenuActionColor
    );
    document.documentElement.style.setProperty("--textColor", textColor);
    document.documentElement.style.setProperty(
      "--textColorActive",
      textColorActive
    );
  }, [bannerBgColor, tabMenuColor, tabMenuActionColor, textColorActive, sidebarColor, textColor]);
}
